import { AttachmentFormValue } from "../hooks/attachment";

export const toAttachmentFormValue = (field: unknown): AttachmentFormValue => {
  const value = field as Record<string, unknown>;
  return {
    id: value.id as string | undefined,
    filename: value.filename as string,
    s3_key: value.s3_key as string,
  };
};
